import React from 'react';
import { Tag } from 'antd';
import { BUYBACK_STATUS_LABEL, type BuybackStatus } from '../../types/buyback';
import { FONT_SIZE, SPACING } from '../../constants/constants';
import { useThemeTokens } from '../../hooks/UseThemeTokens';

/**
 * 매입 오더 상태 태그. 색은 전부 디자인 토큰(useThemeTokens)에서 가져온다.
 *   신규=중립 / 준비중=경고 / 준비완료=액센트 / 완료=성공 / 불성립=위험
 */
export const BuybackStatusTag: React.FC<{ status: BuybackStatus }> = ({ status }) => {
  const t = useThemeTokens();

  const theme: Record<BuybackStatus, { bg: string; text: string; border: string }> = {
    NEW_ORDER: { bg: t.bgRaised,    text: t.textSecondary, border: t.border },
    PREPARING: { bg: t.tintWarning, text: t.warning,       border: t.lineWarning },
    READY:     { bg: t.tintInfo,    text: t.accent,        border: t.lineAccent },
    COMPLETED: { bg: t.tintSuccess, text: t.success,       border: t.lineSuccess },
    CANCELLED: { bg: t.tintDanger,  text: t.danger,        border: t.lineDanger },
  };
  const c = theme[status];

  return (
    <Tag style={{ fontSize: FONT_SIZE.xs, margin: 0, padding: `0 ${SPACING.xxs}px`, background: c.bg, color: c.text, borderColor: c.border }}>
      {BUYBACK_STATUS_LABEL[status]}
    </Tag>
  );
};
